import { isNetworkError } from 'lib/action'

interface OfflineState {
  isOffline: boolean
}

interface OfflineAction {
  type: string
  payload?: {
    status?: number
  }
  error?: {
    status?: number
    response?: {
      status?: number
    }
  }
}

const initialState: OfflineState = {
  isOffline: false,
}

export default (state: OfflineState = initialState, action: OfflineAction): OfflineState => {
  if (window.navigator?.onLine != null) return { isOffline: !window.navigator.onLine }
  let status = action.payload?.status
  status = status ?? action.error?.status
  status = status ?? action.error?.response?.status
  if (status == null) return state
  return { isOffline: isNetworkError(action) }
}
